/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Raffle_Count_MinInputs */



/**
* | output |
* | --- |
* | "Raffle count must be at least 1" |
*
* @param {Err_Tournament_Raffle_Count_MinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_raffle_count_min = /** @type {((inputs?: Err_Tournament_Raffle_Count_MinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Raffle_Count_MinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nombre de tirages doit être au moins 1")
	if (locale === "es") return /** @type {LocalizedString} */ ("El número de sorteos debe ser al menos 1")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O número de sorteios deve ser pelo menos 1")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il numero di estrazioni deve essere almeno 1")
	return /** @type {LocalizedString} */ ("Raffle count must be at least 1")
});